// Mirrors the push rendering in Pickstop.Mobile/web/sw.js, keep the two in sync.

export const formatUtc = (value) =>
	value ? value.replace("T", " ").slice(0, 16) : "-";

export function parsePayload(row) {
	try {
		return JSON.parse(row.payloadJson);
	} catch (e) {
		return null;
	}
}

export function renderText(payload) {
	if (!payload) {
		return { title: null, body: null };
	}

	const eventName = payload.eventName || "Pickstop event";
	const lockDate = formatLockDate(payload.lockDate);
	const before = lockDate ? ` before ${lockDate}` : "";

	switch (payload.type) {
		case "event_opened":
			return {
				title: `Picks are open: ${eventName}`,
				body: `Submit your ${payload.stageName} picks${before}.`,
			};
		case "stage_opened":
			return {
				title: `${payload.stageName} open: ${eventName}`,
				body: `Lock in your picks${before}.`,
			};
		case "pick_reminder":
			return {
				title: `Picks closing soon: ${eventName}`,
				body: `You have no picks in yet${before}.`,
			};
		case "results_ready":
			return {
				title: `Results are in: ${eventName}`,
				body: "See where you placed.",
			};
		case "admin_message":
			return {
				title: payload.title || "Pickstop",
				body: payload.body || "",
			};
		default:
			return { title: null, body: null };
	}
}

function formatLockDate(iso) {
	if (!iso) return null;
	const d = new Date(iso);
	if (isNaN(d.getTime())) return null;
	try {
		return new Intl.DateTimeFormat(undefined, {
			weekday: "short",
			month: "short",
			day: "numeric",
			hour: "numeric",
			minute: "2-digit",
		}).format(d);
	} catch (e) {
		return d.toISOString();
	}
}
